import React, {useState} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Text, View, Pressable } from 'react-native';
import { EXPENSE_LINES_WITH_COUNT } from './queries';
import { useMutation } from '@apollo/client';
import { Link } from 'app/src/utils/routing';
import { useParams } from 'react-router-dom';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import {
   MainContainer,
   ContentContainer,
   TableContainer,
   PageTitle,
   LinkContainer,
   SubNavContainer,
   TableNavbarContainer
} from '../../../elements';
import Modal from '../../../elements/Modal';
import NewExpenseLine from './new';
import EditExpenseLine from './edit';
import currencyFormatter from '../../../utils/currencyFormatter';
import SubNav from '../../../elements/SubNav';
import moment from 'moment';
import elRed from '../../../styles/colors';
import styled from 'styled-components/native';
import { formatAddress } from '../../../utils/formatAssetName';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';

const inputStyle = {
  marginBottom: '10px'
}

export const ExpenseLineRow = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-right: 200px;
  width: 95%;
`;

const CELL_STYLES = `
  border: 1px solid black;
  padding: 10px;
  backgroundColor: #fff;
`;

export const ExpenseLineCell = styled(View)`
  ${CELL_STYLES}
  width: 25%;
`;

export const ExpenseLineCellNoBorder = styled(View)`
  padding: 10px;
  width: 25%;
`;

export const ExpenseLineCellExpanded = styled(View)`
  ${CELL_STYLES}
  width: 40%;
`;

export const ExpenseLineCellExpandedNoBorder = styled(View)`
  padding: 10px;
  width: 40%;
`;

export const ExpenseLineFunctionsCell = styled(View)`
  ${CELL_STYLES}
  width: 15%;
  flex-direction: row;
`;

export const ExpenseLineFunctionsCellNoBorder = styled(View)`
  padding: 10px;
  width: 15%;
  align-content: center;
  flex-direction: row;
  align-items: center;
`;

const HEADER_STYLES = `
  width: 25%;
  padding: 10px;
  background-color: ${elRed};
  border: 1px solid black;
`;

const HeaderText = styled(Text)`
  font-weight: 900;
  color: #fff;
`;

export const ExpenseLineHeader = styled(View)`
  ${HEADER_STYLES}
`;

export const ExpenseLineHeaderExpanded = styled(View)`
  ${HEADER_STYLES};
  width: 40%;
`;

export const ExpenseLineFunctionsHeader = styled(View)`
  ${HEADER_STYLES}
  width: 15%;
`;

const ExpenseLines = (props) => {
  const { assetId } = useParams();
  const { asset, setUnsavedLines, expense, refetch } = props;
  // const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const [clickedExpenseLine, setClickedExpenseLine] = useState(false)
  const [showAddExpenseLine, setShowAddExpenseLine] = useState(false);
  const [expenseLines, setExpenseLines] = useState(expense.expenseLines || []);
  const queryVariables = {
    assetId: assetId,
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  return (
    <View>
      <Text style={{color: elRed, marginTop: '10px', marginBottom: '10px'}}>
        <b>Expense Lines</b>
      </Text>
      <ExpenseLineRow>
        <ExpenseLineHeaderExpanded>
          <HeaderText>Asset</HeaderText>
        </ExpenseLineHeaderExpanded>
        {/* <ExpenseLineHeaderExpanded>
          <Text>Sale</Text>
        </ExpenseLineHeaderExpanded> */}
        <ExpenseLineHeader>
          <HeaderText>Amount</HeaderText>
        </ExpenseLineHeader>
        <ExpenseLineHeader>
          <HeaderText>Description</HeaderText>
        </ExpenseLineHeader>
        <ExpenseLineFunctionsHeader>

        </ExpenseLineFunctionsHeader>
      </ExpenseLineRow>
      {expenseLines?.map(expenseLine => {
        if(parseInt(expenseLine.id) === parseInt(clickedExpenseLine.id)) {
          return (
            <EditExpenseLine
              expenseLine={clickedExpenseLine}
              asset={asset}
              setClickedExpenseLine={setClickedExpenseLine}
              updateExpenseLinesList={updateExpenseLinesList}
            />
          )
        }else {
          return (
            <View>
              <ExpenseLineRow>
                <ExpenseLineCellExpanded>
                  <Text>{expenseLine?.asset?.name}</Text>
                </ExpenseLineCellExpanded>
                {/* <ExpenseLineCellExpanded>
                  <Text>
                    {formatSaleAssetLabel(expenseLine?.saleAsset)}
                  </Text>
                </ExpenseLineCellExpanded> */}
                <ExpenseLineCell>
                  <Text>{currencyFormatter(expenseLine?.amount)}</Text>
                </ExpenseLineCell>
                <ExpenseLineCell>
                  <Text>{expenseLine?.description}</Text>
                </ExpenseLineCell>
                <ExpenseLineFunctionsCell>
                  <Pressable
                    onPress={() => {
                      setClickedExpenseLine(expenseLine);
                      setShowAddExpenseLine(false);
                    }}
                  >
                    <Text>edit</Text>
                  </Pressable>
                </ExpenseLineFunctionsCell>
              </ExpenseLineRow>
            </View>
          )
        }
      })}
      {!expenseLines?.length || (showAddExpenseLine && !clickedExpenseLine) ?
        <NewExpenseLine
          knownAssetId={assetId}
          updateExpenseLinesList={updateExpenseLinesList}
          setShowAddExpenseLine={setShowAddExpenseLine}
          expense={expense}
          refetch={refetch}
        /> :
        <ButtonContainer>
          <ButtonGroup>
            <Button
              label="Add Expense Line"
              onPress={() => setShowAddExpenseLine(true)}
            />
          </ButtonGroup>
        </ButtonContainer>
      }
    </View>
  )

  function formatSaleAssetLabel(saleAsset) {
    let label = '';
    if(saleAsset?.sale?.name) label += `${saleAsset.sale.name} `;
    if(saleAsset?.sale?.saleOn) label += moment(saleAsset.sale.saleOn).format('M-DD-YY');
    if(saleAsset?.correctedLotNumber) label += `\n${saleAsset.correctedLotNumber}`
    return label;
  }

  function updateExpenseLinesList(expenseLine, newResource) {
    let newExpenseLines = expenseLines;
    if(newResource) {
      newExpenseLines = newExpenseLines.length ?
        [...newExpenseLines, expenseLine] : [expenseLine]
    }else {
      newExpenseLines = newExpenseLines?.map(line => {
        if(parseInt(line.id) === parseInt(expenseLine.id)) return expenseLine;
        return line;
      })
    }

    setExpenseLines(newExpenseLines);
  }
}

export default ExpenseLines;
